import { Component } from '@angular/core';
import { IonicPage, NavController } from 'ionic-angular';

import { LoadingController } from 'ionic-angular';
import { ToastController } from 'ionic-angular';

import { QuizzDetailPage } from '../quizz-detail/quizz-detail';

import { NetworkMonitorProvider } from '../../providers/network-monitor/network-monitor';
import { EventEmitterProvider } from '../../providers/event-emitter/event-emitter';
import { QuizzServerProvider } from '../../providers/quizz-server/quizz-server';

/**
 * Generated class for the QuizzListPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-quizz-list',
  templateUrl: 'quizz-list.html',
})
export class QuizzListPage {

  loading: boolean;
  private subscriptions: any = [];
  private doUpdateQuizzSubscription: any;

  constructor(
    private navCtrl: NavController,
    private networkMonitor: NetworkMonitorProvider,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private eventEmitterProvider: EventEmitterProvider,
    private quizzServerProvider: QuizzServerProvider,
  ) {
    this.loading = false;

    this.networkMonitor.setCallback(null);
    this.networkMonitor.stop();

    // Execute first time on enter
    this.doUpdate();

    let that = this;
    this.doUpdateQuizzSubscription = this.eventEmitterProvider.get('do_update_quizz').subscribe(() => {
      that.doUpdate();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad QuizzListPage');
  }

  ionViewWillLeave() {
    this.doUpdateQuizzSubscription.unsubscribe();
  }

  doUpdate() {
    this.loading = true;

    let loader = this.loadingCtrl.create({
      content: 'Obtendo os quizz...',
    });
    loader.present();

    let that = this;
    this.subscriptions = [];

    this.quizzServerProvider.fetchAll().subscribe((subscriptions: any) => {
      that.loading = false;

      try {
        if (subscriptions.length > 0) {
          that.subscriptions = subscriptions;
        }
      } catch (ex) {
        that.doNotRetrived(ex);
      }

      loader.dismiss();
    }, (error: any) => {
      that.loading = false;
      loader.dismiss();
      that.doNotRetrived(error);
    });
  }

  private doNotRetrived(error = null) {
    this.subscriptions = [];

    let toast = this.toastCtrl.create({
      message: 'Não foi possível obter os quizz.',
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  /**
   * Get the detail of quizz.
   * 
   * @param quizz Quizz.
   */
  getDetail(quizz: any) {
    this.navCtrl.push(QuizzDetailPage, {
      quizz: quizz
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/quizz-list/quizz-list.ts